<ng-container *transloco="let convert;">
  @if (!waitingResponse && !successfulResponse) {
    <app-offer-modals-header
      [tenantName]="tenantName"
      heading="{{ convert('vehicles.withDrawOffer.textViewOffer') }}"
      [headingId]="modalId + '-title'"
    ></app-offer-modals-header>
    <div class="modal__content">
      <div class="modal__body">
        <p
          class="text-danger fw-bold"
          [class.d-none]="!errorMessage"
          aria-atomic="true"
          aria-live="polite"
          #error
          >
          @if (errorMessage) {
            {{ convert('vehicles.withDrawOffer.errorMsgTitle') }}
          }
        </p>
        <!--
          M4.8, per Figma 10493:16426. With the flag on the order is: the VIN/DATE/AMOUNT/STATUS strip,
          the all-in breakdown, the history collapsed behind a disclosure, then the binding-offer prose
          naming the total. Flag off, this is byte-for-byte today's modal: expanded history, then
          msgDescription, then textSelectWithdraw.

          The comp keeps the summary strip's bare AMOUNT above the breakdown's OFFER row -- the same
          figure twice. That was listed as an open UX item on M4.5 for counter-offer; the comp answers
          it for this state, so the strip stays.
        -->
        <app-offer-history
          [vin]="item.vin"
          [offerHistory]="offerHistory"
          [collapsible]="showDripBreakdown">
          @if (showDripBreakdown) {
            <!--
              [showCents]="false" per the comp (Figma 11024:11203), which quotes OFFER $53,000,
              SERVICE FEE $400, TRANSPORTATION FEE $350 and TOTAL PURCHASE PRICE $53,750 -- whole
              dollars in every row. Paired with quotedPriceDisplay's withCents: false, and the two
              must move together: the binding sentence quotes the same total this block's last row
              shows, so a mismatch writes one figure two ways inside one modal.

              Bound here rather than flipping ModalPriceBreakdownComponent's default, which stays
              input(true) for the legacy BidModalComponent.
            -->
            <app-modal-price-breakdown
              appOfferHistoryAfterSummary
              [idPrefix]="dripIdPrefix"
              [pattern]="additivePattern"
              [baseAmount]="dripOfferBaseAmount"
              [feeRows]="dripFeeRows"
              [transportationFee]="dripTransportationFee"
              [showCents]="false"
              [translations]="dripBreakdownTranslations">
            </app-modal-price-breakdown>
          }
        </app-offer-history>
        <!--
          M4.14: the ids exist so the prose can be asserted structurally, and now that
          msgDescriptionAllIn carries real copy in the base bundles the specs assert its rendered text
          too -- by key through the bundle, not against a literal. The spy on quotedPriceDisplay stays:
          the text proves WHICH paragraph rendered, the spy proves the figure inside it came from the
          all-in getter. One id across both copy variants: only one ever renders.
        -->
        <p id="vom_binding_text" [innerHTML]="convert(descriptionKey,{vehicleTitle: vehicleTitle, amount: quotedPriceDisplay})">
        </p>
        <!--
          The transportation paragraph exists because the binding sentence above quotes a total that
          INCLUDES transportation, so the all-in buyer has to be told that part is avoidable.
          textSelectWithdraw below is the modal's only explanation of what the button does.

          The transportation paragraph's gate is the QUOTED FEE -- showTransportationDisclosure is the
          same predicate the breakdown's transportation row uses, so the row and the sentence about
          avoiding it cannot drift apart. Do not re-derive it as `fee > 0`.

          showDripBreakdown is in that condition as a DE-DUPLICATION guard, NOT as a feature gate, and
          cannot be dropped: descriptionKey resolves to msgDescription with the flag off, and the ehi /
          ehi_ca overrides of that key already carry this exact sentence inline after a </br></br>.
          Rendering the paragraph there as well would print the same disclosure twice in one modal. The
          all-in variant (msgDescriptionAllIn) does not carry it, which is why this path needs it.

          vom_select_withdraw_text is a hook for the specs, like the other vom_* ids here.
        -->
        @if (showDripBreakdown && showTransportationDisclosure) {
          <p id="vom_transportation_text">
            {{ convert('vehicles.withDrawOffer.msgDescriptionTransportation') }}
          </p>
        }
        <p id="vom_select_withdraw_text">
          {{ convert('vehicles.withDrawOffer.textSelectWithdraw') }}
        </p>
        <div class="col-md-12 error_message" aria-atomic="true" aria-live="polite">
          @if (errorMessage) {
            <p class="text-danger fw-bold" id="counter-offer-amount-error" #error>{{ convert('error.' + errorMessage) }}</p>
          }
        </div>
        <div class="d-flex flex-column flex-lg-row lg-justify-content-start gap-3">
          <button
            id="vom_withdraw_offer_button"
            class="btn btn-primary"
            type="button"
            (click)="withdraw()"
            allytmln="withdrawBuyAction"
            data-track-elem="button"
            data-track-name="Withdraw Offer"
            data-test-id="app-withdraw-offer-e-withdraw-offer-button"
            >
            {{ convert('vehicles.withDrawOffer.textWihtdrawOffer') }}
          </button>
          <button
            id="vom_cancel_button"
            class="ms-lg-2 mt-3 mt-lg-0 btn btn-link"
            type="button"
            (click)="cancel()"
            data-track-elem="button"
            data-track-name="Cancel"
            data-track-trigger="close"
            data-test-id="app-withdraw-offer-e-cancel-button"
            >
            {{ convert('common.btnCancel') }}
          </button>
        </div>
      </div>
    </div>
    <app-modal-close (close)="cancel()" [identifier]="'vom_close_x_button'"></app-modal-close>
  }

  @if (waitingResponse && !successfulResponse) {
    <!-- submitting -->
    <app-action-submitting actionText="{{ convert('vehicles.withDrawOffer.actionTextWithdrawingOffer') }}"></app-action-submitting>
  }

  @if (!waitingResponse && successfulResponse) {
    <!-- success -->
    <app-action-submitted (close)="cancel()" actionText="{{ convert('vehicles.withDrawOffer.actionTextOfferWithdrawn') }}" [tenantName]="tenantName">
    </app-action-submitted>
  }
</ng-container>
